import { render, staticRenderFns } from "./NuevoInforme.vue?vue&type=template&id=7d49f9bf&scoped=true"
import script from "./NuevoInforme.vue?vue&type=script&lang=js"
export * from "./NuevoInforme.vue?vue&type=script&lang=js"
import style0 from "./NuevoInforme.vue?vue&type=style&index=0&id=7d49f9bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d49f9bf",
  null
  
)

export default component.exports